import { render, staticRenderFns } from "./AppComparison.vue?vue&type=template&id=2307c6d0&scoped=true&"
import script from "./AppComparison.vue?vue&type=script&lang=js&"
export * from "./AppComparison.vue?vue&type=script&lang=js&"
import style0 from "./AppComparison.vue?vue&type=style&index=0&id=2307c6d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2307c6d0",
  null
  
)

export default component.exports